import React from "react";
import logo from "../../../media/logo-black.png"
import { AmenitiesList } from "../SchedulePages/Canada/metadata";

const TorontoMeta = {
    hero: {
        title: "Non-Stop Daily Service to Toronto Pearson Airport (YYZ)",
        subtitle: "Begin and end your journey closer to home in Kitchener-Waterloo (YKF) or Hamilton(YHM)"
    },
    header: {
        title: "Skip The Drive - Relax and Ride Landline",
        subtitle: <><p>
            Avoid the hassle of driving to Toronto only to pay expensive tolls, YYZ parking fees, and vehicle wear and tear. Let Landline do the driving for you.
        </p>
            <p>
                Landline offers two convenient ways for Air Canada passengers to book yourconnecting motorcoach service - depending on your travel needs.
            </p></>
    },
    titles: {
        locations: "Locations & Schedules",
        amenities: "Amenities"
    },
    seo: {
        title: "Air Canada Airport Transfers from Hamilton & Kitchener-Waterloo to Toronto Pearson | Landline",
        description: "Landline offers exclusive, reliable, comfortable, motorcoach service for Air Canada and Air Canada Vacations passengers between Hamilton (YHM), Kitchener-Waterloo (YKF), and Toronto Pearson (YYZ). One seamless, stress-free booking."
    }
}

const CanadaOptions = {
    title: "Choose The Best Option for Your Trip",
    options: [
        {
            title: "Book Through Air Canada",
            logo: "https://content.landline.com/wp-content/uploads/2025/01/aircanada-logo.png",
            subtitle: "(Like a Connecting Flight)",
            benefits: {
                title: "Benefits:",
                list: [
                    <><b>Itinerary Protection:</b> Your bus and flight are connected under a single booking. If your bus is delayed, Air Canada will reacommodate you on the next departure</>,
                    <><b>Earn Aeroplan Points:</b> Earn points and build status as you ride the luxury motorcoach</>,
                    <><b>One Simple Price:</b> Pay one fare for both your flight and bus transportation</>
                ]
            },
            bestif: {
                title: "Best If:",
                list: [
                    "You want full travel protection and have not yet booked your Air Canada flight.",
                    "Book your shuttle and air ticket together by searching Hamilton (YHM) or Kitchener-Waterloo (YKF) to your final destination on aircanada.com."
                ]
            },
            button: {
                title: "Book with Air Canada",
                link: "https://www.aircanada.com/"
            }
        },
        {
            title: "Book Through Landline",
            logo: logo,
            subtitle: "(Simple, Easy Shuttle Service)",
            benefits: {
                title: "Benefits:",
                list: [
                    <><b>Quick & Simple Booking:</b> Book your shuttle in minutes. Easily
                        change and manage your reservation through Landline without affecting
                        your flight.</>, <><b>Flexible Scheduling:</b> Book one way or round trip. Easily choose
                            the shuttle time that fits your schedule and preferences.</>, <><b>Affordable Fares:</b> Only $49 per adult. Kids 12 and under ride
                                FREE!</>
                ]
            },
            bestif: {
                title: "Best If:",
                list: [
                    "You already booked your Air Canada flight",
                    "You booked though Air Canada Vacations (ACV)",
                    "You only need to motor coach service one way",
                    "Ideal for last-minute bookings"
                ]
            },
            button: {
                title: "Book with Landline",
                link: "https://ca.landline.com/"
            }
        }
    ]
}

const English = {
    meta: TorontoMeta,
    options: CanadaOptions,
    amenities: AmenitiesList,
    english: true,
    french: false,
}

export {
    TorontoMeta, CanadaOptions, English
}